<template>
	<div
		class="flex items-center justify-center rounded-full bg-won-green-light text-[100%]"
		:style="`width: ${diameterPx}px; height: ${diameterPx}px;`"
	>
		<span class="text-[1em] text-won-lime uppercase">
			{{ firstLetter }}
		</span>
	</div>
</template>

<script setup>
import { computed, toRefs } from 'vue';

const props = defineProps({
	userName: {
		type: String,
		default: null
	},
	diameterPx: {
		type: Number,
		default: 24
	}
});

const { userName } = toRefs(props);

const firstLetter = computed(() => {
	return userName.value?.charAt(0) || '?';
});
</script>
